import { CommaSeparatedLinks } from '~/components/comma-separated-links';
import { Container } from '~/components/layout';
import { Text } from '~/components/typography';
import { ContractVersion } from '~/typings/context';
import { ContractLinkScreen } from '~/utils/logger';

export type TermsTextProps = {
  contracts: ContractVersion[];
  preText?: any;
  postText?: string;
  lastConjunction?: string;
  textAlign?: 'left' | 'center';
  originationSourceType?: string;
  inReviewScreen?: boolean;
  utilityAccountId?: number;
  showPersonalizedContractPreview?: boolean;
  planId?: number;
  setErrorInRender?: (error: boolean) => void;
  /** The screen rendering these links; owns the interaction attributes. (SUBEXP-3193) */
  screen: ContractLinkScreen;
};

export const TermsText = ({
  contracts = [],
  preText = 'I have read the',
  postText = '. By proceeding, I will be submitting my e-signature.',
  lastConjunction = ' and the ',
  textAlign = 'left',
  originationSourceType,
  inReviewScreen = false,
  utilityAccountId,
  planId,
  showPersonalizedContractPreview = false,
  setErrorInRender = () => {},
  screen,
}: TermsTextProps) => {
  if (!contracts.length) return null;
  const preTextSponsoredSolar =
    'By checking this box, I affirm that I have first and separately reviewed the';
  const middleTextSponsoredSolar =
    ' and agree to its terms and conditions. By checking this box, I also affirm that I have reviewed, read and agree to the terms and conditions of the ';
  const postTextSponsoredSolar =
    '. By checking this box, I understand and agree that my electronic signature will be applied to all of these agreements and will bind me to all Agreement terms and conditions.';
  const sponsoredSolar = originationSourceType === 'sponsored_solar';
  const contractsMap = {};
  contracts.forEach(contract => {
    contractsMap[contract.displayName] = contract;
  });

  const renderLinks = (contractKeys: string[]) => {
    const contractsList = contractKeys.map(key => contractsMap[key]);
    const hasAllContracts = contractsList.every(
      contract => contract !== undefined && contract !== null,
    );
    setErrorInRender(!hasAllContracts);
    if (!hasAllContracts) return null;
    return (
      <CommaSeparatedLinks
        lastConjunction={lastConjunction}
        contracts={contractsList}
        linkProps={{ color: 'secondary' }}
        utilityAccountId={utilityAccountId}
        showPersonalizedContractPreview={showPersonalizedContractPreview}
        screen={screen}
      />
    );
  };

  if (inReviewScreen && sponsoredSolar) {
    return (
      <Text textStyle="paragraph400" color="secondary" textAlign={textAlign}>
        {preTextSponsoredSolar} {renderLinks(['Community Solar Agency Agreement'])}
        {middleTextSponsoredSolar}
        {renderLinks(['Disclosure form', 'Solar Beneficiary Agreement'])}
        {postTextSponsoredSolar}
      </Text>
    );
  }

  return (
    <Container>
      <Text textStyle="paragraph400" color="secondary" textAlign={textAlign}>
        {preText}{' '}
        <CommaSeparatedLinks
          lastConjunction={lastConjunction}
          contracts={contracts}
          linkProps={{ color: 'secondary' }}
          utilityAccountId={utilityAccountId}
          planId={planId}
          showPersonalizedContractPreview={showPersonalizedContractPreview}
          screen={screen}
        />
        {postText}
      </Text>
    </Container>
  );
};
